import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { generateIdRoutePath } from '../../../helpers';
import { GAME_DB } from '../../../db/game';
const SHOW_COUNT_KEY = 'saveGameResultModalCount';
const SaveGameResult = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [showEndSession, setShowEndSession] = useState(false);
    const hasIncremented = useRef(false);
    useEffect(() => {
        if (hasIncremented.current)
            return;
        hasIncremented.current = true;
        const count = Number(sessionStorage.getItem(SHOW_COUNT_KEY) || '0') + 1;
        sessionStorage.setItem(SHOW_COUNT_KEY, String(count));
        if (count > 2) {
            setShowEndSession(true);
        }
    }, []);
    const handleEndGameSession = () => {
        dispatch(setModalContent(MODAL_CONTENT.confirmEndGameSession.key));
    };
    return (_jsxs("div", { className: 'modal-content save-game-result', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('save_game_result'), type: 'h1' }) }), _jsxs("div", { className: "modal-content-button", children: [showEndSession && (_jsx(Button, { label: t('button.end_game_session'), variant: 'outlined', onClick: handleEndGameSession })), _jsx(Button, { label: t('button.ok'), onClick: async () => {
                            dispatch(setIsModalOpen(false));
                            dispatch(setModalContent(null));
                            const rally = await GAME_DB.GET.rallyInfo();
                            if (rally?.uuid) {
                                navigate(generateIdRoutePath(APP_ROUTES.rallyGameResult, String(rally.uuid)));
                            }
                        } })] })] }));
};
export default SaveGameResult;
